import { RootState, useAppSelector } from "cache/store";
import alertMsg from "components/alert-message/alert-message";
import { Game3rdMenuItem, MenuHeaderItem } from "models/commonModel";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from './header-menu.style';
import globalStyle from "constants/global.style";
import classNames from "classnames";
import HeaderMenuLottery from "./HeaderMenuLottery";
import Modal from "components/modal/Modal";
import userApi from "apis/userApi";
import toast from "react-hot-toast";
import { tryImg } from "utils/safeImage";

interface Props {
    onPlayGame: (game: Game3rdMenuItem) => void;
}

function HeaderMenu(props: Props) {
    const { onPlayGame } = props;
    const { pathname } = useLocation();
    const { menuGame } = useAppSelector((state: RootState) => state.system);
    const { isLogged } = useAppSelector((state: RootState) => state.auth);
    const listMenuRef = useRef<any[]>([]);
    const [menuGameList, setMenuGameList] = useState<MenuHeaderItem[]>(menuGame);
    const [showGift, setShowAuth] = useState(false);
    const navigate = useNavigate();
    const giftCodeRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (menuGame.length > 0) {
            const lotteryMenu: MenuHeaderItem = {
                name: 'Xổ Số',
                child: [],
                isMain: false,
                isLottery: true,
                path: '/lottery',
                icon: "lottery-icon"
            };

            let newMenuGame = [...menuGame];
            newMenuGame.splice(3, 0, lotteryMenu);
            setMenuGameList(newMenuGame);
        }
    }, [menuGame]);

    const onHoverMenuGame = (index: number, isHover: boolean) => {
        const listMenuSelect: HTMLDivElement = listMenuRef.current[index];
        if (listMenuSelect) {
            if (isHover) {
                (listMenuSelect.closest('.game-wrap') as HTMLDivElement).style.height = `${listMenuSelect.clientHeight}px`;
            } else {
                (listMenuSelect.closest('.game-wrap') as HTMLDivElement).style.height = '0';
            }
        }
    }

    const selectGame = (game: Game3rdMenuItem, index: number) => {
        if (!isLogged) {
            alertMsg('Vui lòng đăng nhập');
            onHoverMenuGame(index, false);
            return;
        }
        onPlayGame(game);
    }
    const goToLobby = (game: MenuHeaderItem, index: number) => {
        if (game.gametype && game.gametype !== 'OT') {
            navigate(`/lobby?type=${game.gametype}`);
            onHoverMenuGame(index, false);
        }
    };

    const getGiftCode = async () => {
        const valueInput = giftCodeRef.current?.value.trim() || "";

        if (valueInput === "") {
            alertMsg("Vui lòng nhập mã xác nhận!");
            return;
        }

        const params = {
            giftcode: valueInput,
        };

        try {
            const {data} = await userApi.giftCode(params);

            if (data.errorCode === 1) {
                alertMsg(data.msg);
            } else {
                alertMsg(data.msg);
                setShowAuth(false);
            }
        } catch (error) {
            alertMsg("Đã xảy ra lỗi khi gửi mã.");
        }
    };

    return (
    <>
        <div className={styles.wrap}>
            <div className={globalStyle.container}>
                <ul className={styles.menuList}>
                    {menuGameList.map((item, index) => (
                        <li
                            className={classNames(styles.menuItem, { active: item.path === pathname })}
                            key={index}
                            onMouseEnter={() => onHoverMenuGame(index, true)}
                            onMouseLeave={() => onHoverMenuGame(index, false)}
                        >
                            {item.path ? (
                                <Link className={styles.menuLink} to={item.path}>
                                    <img src={tryImg(() => require(`assets/images/header/${item.icon}.png`))} alt="" />
                                    {item.name}
                                </Link>
                            ) : (
                                <h6 className={styles.menuLink} onClick={() => goToLobby(item, index)}>
                                    <img src={tryImg(() => require(`assets/images/header/${item.icon}.png`))} alt="" />
                                    {item.name}
                                </h6>
                            )}

                            {/* game base list */}
                            {item.child && (
                                <div className={`${styles.baseGameHover} game-wrap`}>
                                    <div className={globalStyle.container}>
                                        <div className={`${styles.gameList} game-list`} ref={(el) => (listMenuRef.current[index] = el)}>
                                            {!item.isLottery ? (
                                                item.child.map((game, i) => (
                                                    <div className={styles.gameItem} key={i} onClick={() => selectGame(game, index)}>
                                                        <img className={`${item.gametype === 'SL' ? 'img' : ""}`} src={tryImg(() => require(`assets/images/header/${game.iconpc}.png`))} alt="" />
                                                        <p className={styles.gameName}>
                                                            <img src={require(`assets/images/icons/btn-bet.png`)} alt="" />
                                                        </p>
                                                    </div>
                                                ))
                                            ) : (
                                                <HeaderMenuLottery onCloseMenu={onHoverMenuGame} menuIndex={index} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </li>
                    ))}
                    <li className={styles.giftCode} onClick={() => setShowAuth(true)}>
                        <img src={require(`assets/images/header/giftimg.png`)} alt="" />
                        <img className="active" src={require(`assets/images/header/giftimg-active.png`)} alt="" />
                    </li>
                </ul>
            </div>
        </div>

        <Modal isShow={showGift} onClose={() => setShowAuth(false)} backdropColor="rgba(0,0,0, 0.5)" width="100%">
            <div className={styles.giftCodeContent}>
                <div className="giftcode">
                    <img className="close" onClick={() => setShowAuth(false)} src={require('assets/images/header/close-gift.png')} alt="" />
                    <img src={require('assets/images/header/content-giftcode.png')} alt="" />
                    <div className="input-code">
                        <p>Nhập mã code</p>
                        <input ref={giftCodeRef} type="text" placeholder="..." />
                    </div>
                    <button onClick={() => getGiftCode()} className="submit"><img src={require('assets/images/header/xacnhan.png')} alt="" /></button>
                </div>
            </div>
        </Modal>
    </>
    )
}

export default HeaderMenu;